var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM8 15C6.52375 15 5.155 14.5381 4.025 13.755C4.15313 12.2156 5.43125 11 7 11H9C10.5703 11 11.8481 12.2169 11.9753 13.755C10.8438 14.5375 9.475 15 8 15ZM12.8656 13.0219C12.425 11.2906 10.8656 10 9 10H7C5.13344 10 3.575 11.2906 3.13438 13.0225C1.82094 11.7219 1 9.96875 1 8C1 4.14062 4.14062 1 8 1C11.8594 1 15 4.14062 15 8C15 9.96875 14.1781 11.7219 12.8656 13.0219ZM8 4C6.61875 4 5.5 5.11875 5.5 6.5C5.5 7.88125 6.61875 9 8 9C9.38125 9 10.5 7.88062 10.5 6.5C10.5 5.11875 9.38125 4 8 4ZM8 8C7.17188 8 6.5 7.32812 6.5 6.5C6.5 5.67188 7.17188 5 8 5C8.82812 5 9.5 5.67281 9.5 6.5C9.5 7.32719 8.82812 8 8 8Z"}));
}

Profile.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Profile;

Profile.default = Profile;
